import { render, staticRenderFns } from "./CognitoAdmins.vue?vue&type=template&id=73b7759a&scoped=true&"
import script from "./CognitoAdmins.vue?vue&type=script&lang=js&"
export * from "./CognitoAdmins.vue?vue&type=script&lang=js&"
import style0 from "./CognitoAdmins.vue?vue&type=style&index=0&id=73b7759a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b7759a",
  null
  
)

export default component.exports